module.exports = __webpack_public_path__ + "static/media/tip-intro.dda86c39.mp3";